module.exports = __webpack_public_path__ + "static/media/enfase-1.9d128399.jpg";